import { Check } from "lucide-react";

interface Step {
  number: number;
  label: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

const StepIndicator = ({ steps, currentStep }: StepIndicatorProps) => {
  return (
    <div className="flex items-center justify-center p-4 sm:p-8 w-full h-full">
      <div className="flex items-center justify-center w-full">
        {steps.map((step, index) => (
          <div key={step.number} className="flex items-center flex-1">
            {/* Step Circle and Label */}
            <div className="flex items-center space-x-2 sm:space-x-4">
              <div
                className={`w-8 h-8 sm:w-10 sm:h-10 shrink-0 rounded-full flex items-center justify-center font-semibold text-sm transition-colors ${
                  currentStep > step.number
                    ? "bg-[#BDCC87] text-white"
                    : "bg-gray-200 text-gray-500"
                }`}
              >
                {currentStep > step.number ? <Check /> : step.number}
              </div>
              <span
                className={`${
                  currentStep === step.number ? "inline" : "hidden sm:inline"
                } text-sm font-medium transition-colors ${
                  currentStep >= step.number
                    ? "text-hColor font-semibold"
                    : "text-hColor"
                }`}
              >
                {step.label}
              </span>
            </div>

            {/* Connecting Line */}
            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 sm:mx-8 rounded-full transition-colors ${
                  currentStep > step.number ? "bg-[#BDCC87]" : "bg-gray-200"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
